<template>
    <div class="event-screen activity w-100 h-100 overflow-hidden d-flex flex-column position-relative" v-if="$store.state.game.user">
        <div class="custom-background" :style="{ backgroundImage: `url('${$store.state.game.images?.activity_image}')`}"></div>
        <template v-if="$store.state.game.question">
            <div :class="'d-flex flex-column h-100 w-100' + ((title == true) ? ' d-none' : '')">
                <PlayerTopbar :timer="!!(clock_time && countdown.minutes != null && countdown.seconds != null) || manual_advance">
                    <StageProgress v-if="progress" :types="progress.types" :index="progress.index" :color="own_jersey_color || undefined" />
                    <div class="activity-topbar-segment" v-if="$store.state.game.question.question.segment"><i class="bi bi-signpost-split-fill me-1"></i>{{ utils.get_segment_label($store.state.game.question.question.segment) }}</div>
                </PlayerTopbar>
                <div v-if="clock_time && countdown.minutes != null && countdown.seconds != null" class="activity-timer" id="clock-container">
                    <svg width="88" height="88" viewBox="0 0 100 100" class="activity-timer-ring">
                        <circle cx="50" cy="50" r="42" fill="none" stroke-width="10" class="activity-timer-track"/>
                        <circle cx="50" cy="50" r="42" fill="none" stroke-width="10" stroke-linecap="round" class="activity-timer-progress"
                            :stroke-dasharray="ring_circumference"
                            :stroke-dashoffset="ring_circumference * ring_percent"
                            transform="rotate(-90 50 50)"/>
                    </svg>
                    <span class="clock-text">{{ countdown.minutes }}:{{ countdown.seconds }}</span>
                </div>
                <!-- No clock to show: the presenter decides when this ends. -->
                <div v-else-if="manual_advance" class="activity-presenter">
                    <i class="bi bi-person-video3 me-2"></i>Avanza el presentador
                </div>
                <div class="flex-fill overflow-auto p-4 position-relative" id="question-bg">
                    <div class="event-question-label" v-if="progress">Pregunta {{ progress.index + 1 }} de {{ progress.types.length }}</div>
                    <div id="text-region" class="animate__animated animate__fadeInDown" v-html="format_title($store.state.game.question.question.title)"></div>
                    <div id="question-body" :inert="$store.state.game.user.role === utils.USER_ROLES.MANAGER ? true : null" class="w-100 mt-4">
                        <template v-if="$store.state.game.question.question.type == utils.ACTIVITY_TYPE.QUIZ">
                            <quiz></quiz>
                        </template>
                        <template v-if="$store.state.game.question.question.type == utils.ACTIVITY_TYPE.QUIZ_MULTIPLE">
                            <quiz-multiple></quiz-multiple>
                        </template>
                        <template v-if="$store.state.game.question.question.type == utils.ACTIVITY_TYPE.CROSSWORD">
                            <cross-word></cross-word>
                        </template>
                        <template v-if="$store.state.game.question.question.type == utils.ACTIVITY_TYPE.TRUE_FALSE">
                            <true-false></true-false>
                        </template>
                        <template v-if="$store.state.game.question.question.type == utils.ACTIVITY_TYPE.RANGE">
                            <range></range>
                        </template>
                        <template v-if="$store.state.game.question.question.type == utils.ACTIVITY_TYPE.TEXT">
                            <text-activity></text-activity>
                        </template>
                        <template v-if="utils.is_content_activity($store.state.game.question.question.type)">
                            <content-activity></content-activity>
                        </template>
                    </div>
                </div>
                <PlayerFooter />
            </div>
        </template>

        <div class="modal fade p-3" id="previewImageModal" tabindex="-1" aria-labelledby="previewImageModal" aria-hidden="true">
            <div class="modal-dialog modal-fullscreen w-100 h-100">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5 text-black" id="previewImageModal">Imagen</h1>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body bg-dark bg-opacity-25 w-100 h-100 d-flex justify-content-center align-items-center">
                        <div class="w-100 h-100 d-flex justify-content-center align-items-start">
                            <img class="img-fluid" :src="preview_img">
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PlayerTopbar from '@/components/PlayerTopbar.vue'
import PlayerFooter from '@/components/PlayerFooter.vue'
import Quiz from '@/components/type/Quiz.vue'
import QuizMultiple from '@/components/type/QuizMultiple.vue'
import TrueFalse from '@/components/type/TrueFalse.vue'
import Range from '@/components/type/Range.vue'
import TextActivity from '@/components/type/Text.vue'
import CrossWord from '@/components/type/CrossWord.vue'
import ContentActivity from '@/components/type/Content.vue'

import Avatar from '@/components/Avatar'
import StageProgress from '@/components/StageProgress.vue'
import { stageProgress } from '@/utils/stage-progress'
import utils from '@/../../shared/utils'

export default {
    name: 'Activity',
    components: {
        PlayerTopbar,
        PlayerFooter,
        Quiz,
        QuizMultiple,
        TextActivity,
        TrueFalse,
        Range,
        CrossWord,
        ContentActivity,
        Avatar,
        StageProgress
    },
    data(){
        return {
            utils: utils,
            title: false,
            interval: null,
            ring_circumference: 2 * Math.PI * 42,
            ring_percent: 0,
            countdown: {
                minutes: null,
                seconds: null
            },
            preview_img: null,
            img_preview: false,
        };
    },
    unmounted() {
        if(this.interval != null){
            clearInterval(this.interval);
        }
    },
    mounted(){
        console.log("Activity.vue mounted")
        this.prepare_countdown();
        if(window.store.state.network == "connected" && this.$store.state.game.current_question)
            window.network.wso.send(JSON.stringify({action: window.RPC.UPDATE_VIEW, params: {user: this.$store.state.game.user, view: window.router.currentRoute._value.name, activity: (this.$store.state.game.question) ? this.$store.state.game.question.question.id : null}}))

        $('#preview-img').click(function(){
            this.toggle_imgpreview();
        }.bind(this));

        $('.modal-backdrop').remove();

    },
    watch:{
        // Watching the whole `question` object would refire on every
        // CLIENT_UPDATE broadcast - client.js's client_update() rebuilds
        // `game.question` from scratch on every single update regardless
        // of whether the active question actually changed, and those
        // broadcasts fire very often. That kept tearing the countdown
        // interval down before it could tick, so the ring only seemed to
        // advance when some other event (like a click) happened to
        // coincide with one of its rare surviving ticks. current_question
        // isn't enough either: the server launches a question with
        // end_time null (LANZAR / launch_title) and only fills in the real
        // value once the timed countdown actually starts (COMENZAR /
        // launch_activity) - same question id both times, so a
        // current_question watcher never fires for that second step.
        // Watching end_time itself catches both transitions, and Vue's
        // dot-path watcher compares the primitive value, not any wrapping
        // object's identity, so it's immune to the reference-churn problem
        // too.
        '$store.state.game.question.question.end_time' : function(){
            this.prepare_countdown();
        }
    },
    computed:{
        clock_time : function(){
            return (this.$store.state.game.question) ? this.$store.state.game.question.question.end_time : null;
        },
        // Where we are in the current stage - see utils/stage-progress.js.
        progress(){
            return stageProgress(this.$store.state.game);
        },
        manual_advance(){
            const question = this.$store.state.game.question;
            return window.MODE != utils.APP_MODES.ONLINE && !!question && utils.is_manual_advance(question.question);
        },
        own_jersey_color(){
            const user = this.$store.state.game.user;
            return (user && user.avatar_style && user.avatar_style.color) || null;
        }
    },
    methods:{
        prepare_countdown(){
            if(this.interval != null)
                clearInterval(this.interval);

            if(this.clock_time)
                this.interval = setInterval(this.update_countdown, 100);
        },
        toggle_imgpreview(){
            this.img_preview = !this.img_preview;
        },
        format_title(title){
            // Expresión regular para encontrar enlaces en el texto
            const regex = /https?:\/\/[^\s]+/g;

            // Reemplazar enlaces en el texto con botones
            const textoConBoton = title.replace(regex, (match) => {
                this.preview_img = match;
                return `<button type="button" class="btn btn-sm btn-primary" data-bs-toggle="modal" data-bs-target="#previewImageModal">ver imagen</button>`;
            });

            return textoConBoton;
        },
        update_countdown: function(){

            const currentTime = Date.now();
            const timeRemaining = this.clock_time - currentTime;

            if (timeRemaining <= 0) {
                // Just stop ticking - do NOT guess the next state locally.
                // This used to force game.state to RESULT itself (a shortcut
                // from when CHOICES always led straight there anyway), but
                // an active stage playback may now hold at CHOICES for as
                // long as a sector takes (or forever, for an empty one
                // waiting on the admin) - forcing RESULT here fought the
                // server's real broadcasts every time one arrived, bouncing
                // Activity<->Result and re-triggering both views' entrance
                // animations in a loop. The real CLIENT_UPDATE (already on
                // its way once the server's own timer fires) is the only
                // thing allowed to decide what comes next.
                clearInterval(this.interval);
            } else {
                
                const minutes = Math.floor(timeRemaining / 60000);
                const seconds = Math.floor((timeRemaining % 60000) / 1000);

                // Add leading zeros to minutes and seconds if necessary
                const formattedMinutes = String(minutes).padStart(2, '0');
                const formattedSeconds = String(seconds).padStart(2, '0');

                // Update the countdown clock
                this.countdown.minutes = formattedMinutes;
                this.countdown.seconds = formattedSeconds;

                // Drive the progress ring off the question's own start/end
                // time, not the countdown text, so it empties smoothly
                // instead of jumping once a second.
                const question = this.$store.state.game.question.question;
                const total = question.end_time - question.start_time;
                if(total > 0){
                    const elapsed = currentTime - question.start_time;
                    this.ring_percent = Math.max(0, Math.min(1, elapsed / total));
                }
            }
        },
            }
}
</script>

<style scoped>
    .activity{
        background-color: var(--vc-paper-200);
    }

    .activity-topbar-segment{
        font-family: "Archivo", sans-serif;
        font-weight: 700;
        font-size: 0.7rem;
        text-transform: uppercase;
        letter-spacing: 0.04em;
        color: var(--vc-accent-500);
        margin-top: 2px;
    }

    #logos img{
        max-height: 32px;
    }

    /* Extra top clearance beyond p-4's plain 24px, so the title never sits
       right up against the floating countdown badge above it (.activity-
       timer) - and enough bottom clearance that the last option, scrolled
       all the way down, clears the jersey card floating over the footer
       (see PlayerFooter.vue) instead of stopping short of the
       real bottom of this scroll area. */
    #question-bg{
        border-radius: 0;
        padding-top: 2.5rem !important;
        padding-bottom: 6rem !important;
    }

    .activity-timer{
        position: relative;
        align-self: center;
        margin-top: -46px;
        z-index: 20;
        width: 108px;
        height: 108px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: var(--vc-paper-50);
        border-radius: 16px;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
    }

    .activity-presenter{
        position: relative;
        align-self: center;
        margin-top: -22px;
        z-index: 20;
        padding: 10px 18px;
        background-color: var(--vc-paper-50);
        border-radius: 999px;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
        font-family: "Archivo", sans-serif;
        font-weight: 800;
        font-size: 0.85rem;
        text-transform: uppercase;
        letter-spacing: 0.04em;
        color: var(--vc-ink-900);
    }

    .activity-timer-ring{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .activity-timer-track{
        stroke: var(--vc-line);
    }

    .activity-timer-progress{
        stroke: var(--vc-accent-500);
        transition: stroke-dashoffset 0.1s linear;
    }

    .clock-text{
      	font-family: "Archivo", sans-serif;
        font-weight: 800;
        color: var(--vc-ink-900);
        font-size: 1rem;
        position: relative;
    }
</style>
